import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class TimeoutDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"TEMPS MORT"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "TEMPS MORT",
          };
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team"].includes(key)){
            let commentaire = "Temps mort"

            const team = getTeam(this.team, match)

            if(team){
                commentaire += ' pour '+ team.name
            }

            commentaire += "! "
            
            this.text = commentaire
        }
    }
}